(function () {
    'use strict';

    BatteryTestingListController.$inject =
        ['$scope',
            'SurveyResultService',
            '$window',
            'PatientService',
            'ipmConstants',
            '$state',
            'InvitationService'
        ];

    function BatteryTestingListController(
        $scope,
        SurveyResultService,
        $window,
        PatientService,
        constants,
        $state,
        InvitationService
    ) {
        var vm = this; //jshint ignore:line
        vm.surveyResults = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'id';
        vm.isSendingInvitation = false;
        vm.loadAll = loadAll;
        vm.resendHAQBattery = resendHAQBattery;
        vm.isDisableLaunchResendHAQBattery = isDisableLaunchResendHAQBattery;

        init();

        function init() {
            vm.isManager = vm.isManager ? vm.isManager : false;
            vm.pageableHaq = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            vm.isLoading = true;
            var pageable = {
                page: vm.page > 0 ? vm.page - 1 : vm.page,
                size: vm.pageSize,
                sort: sort()
            };

            SurveyResultService.findByPatientPaganition(vm.patientId, constants.SURVEY_RESULT_TYPE_BATTERY, pageable).then(function (response) {
                vm.pageableHaq.totalItems = response.totalElements;
                vm.isLoading = false;
                if (response.content !== undefined) {
                    vm.surveyResults = response.content;
                } else {
                    vm.surveyResults = [];
                }
            });
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function lunchHAQPatientAutoLogin(haqBattery) {
            if (!haqBattery.patientId || !haqBattery.id) {
                return;
            }
            PatientService.getPatientByIdAndAutoLogin(haqBattery.patientId, haqBattery.id).then(function (res) {
                $window.localStorage.setItem(constants.SURVEY_RESULT_ID, haqBattery.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.HAQ_BATTERY);
                $state.go('home');
            });
        }

        function resendHAQBattery(sr){
            if (vm.isSendingInvitation === true || isDisableLaunchResendHAQBattery(sr)) {
                return;
            }
            var surveyResultId = sr.id;

            vm.isSendingInvitation = true;
            InvitationService.resendHAQ(surveyResultId).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    _.forEach(vm.surveyResults, function(s) {
                        if (s.id === surveyResultId && s.status === 'INCOMPLETE') {
                            s.status = 'STARTED';
                        } else if (s.id === surveyResultId && s.status === 'NO_RESULT') {
                            s.status = 'NOT_STARTED';
                        }
                    });
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
                }
            });
        }

        function isDisableLaunchResendHAQBattery(sr) {
            return (sr && sr.patientCase && sr.patientCase.billableConfig && sr.patientCase.billableConfig.haqTestServiceExclusion) || vm.isBiller;
        }

        vm.loadPage = function (page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.getIndex = function (index) {
            var result = (index + 1) + (vm.page - 1) * vm.pageSize;
            return result;
        };

        vm.goToHAQBattery = function ($event, haqBattery) {
            $event.preventDefault();
            lunchHAQPatientAutoLogin(haqBattery);
        };
    }

    angular.module('ipmApp').component('batteryTestingList', {
        bindings: {
            patientId: '<',
            isManager: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/battery-testing/battery-testing-list.html',
        controller: BatteryTestingListController,
        controllerAs: 'vm'
    });
})();
